export default "__VITE_ASSET__hnmynSia__"